import React, { useEffect, useState } from 'react'
import get from 'lodash/get'
import { compose } from 'redux'
import { withRouter } from 'react-router'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import FlatModal from '../../ui/FlatModal'
import Heading from 'constructicon/heading'
import ProfilePicture from './ProfilePicture'
import SelfDonate from './SelfDonate'
import SharePage from './SharePage'
import Tags from './Tags'

const shouldPromptUser = ({ customSupporterPage, fundraisingPage, tagDefinitions }) => {
  const requiredTags = tagDefinitions.filter(tag => tag.required)
  const isMissingFitnessGoal =
    get(customSupporterPage, 'fitness.showGoal') &&
    parseFloat(fundraisingPage.fitnessGoal) <= 0
  const isMissingTags =
    requiredTags
      .map(tag => fundraisingPage.segmentation[tag.id])
      .filter(Boolean).length !== requiredTags.length

  return get(customSupporterPage, 'onboarding.promptTags') &&
    (isMissingFitnessGoal || isMissingTags)
}

const OnboardingWizard = ({
  classNames,
  customSupporterPage,
  fundraisingPage,
  location: { query },
  onClose,
  router,
  styles,
  tagDefinitions,
  user
}) => {
  const [step, setStep] = useState(query.wizard)
  const promptTags = shouldPromptUser({ customSupporterPage, fundraisingPage, tagDefinitions })

  const handleChangeStep = step => {
    setStep(step)
    window.history.pushState(null, null, `?wizard=${step}`)
  }

  const steps = {
    tags: {
      Component: Tags,
      heading: 'Please complete your profile',
      onNext: () =>
        get(customSupporterPage, 'onboarding.continuteAfterTags')
          ? router.push(`${fundraisingPage.url}?wizard=picture`)
          : onClose(),
      required: promptTags
    },
    picture: {
      Component: ProfilePicture,
      heading: 'Step 1: Upload a profile picture',
      onNext: () => handleChangeStep('share')
    },
    share: {
      Component: SharePage,
      heading: 'Step 2: Share your page',
      onNext: () => handleChangeStep('donate')
    },
    donate: {
      Component: SelfDonate,
      heading: 'Step 3: Get the ball rolling',
      onNext: onClose
    }
  }

  const { Component, heading, onNext, required } = steps[step] || steps.picture

  useEffect(() => {
    if (query.wizard) handleChangeStep(query.wizard)
  }, [query.wizard])

  useEffect(() => {
    if (promptTags) router.push(`${fundraisingPage.url}?wizard=tags`)
  }, [])

  return (
    <FlatModal
      closeIcon={required && false}
      contentLabel='Setup your page'
      isOpen={!!query.wizard}
      onRequestClose={() => !required && onClose()}
      styles={styles.root}
    >
      <Heading>Setup your page</Heading>
      <div className={classNames.stepHeading}>{heading}</div>
      <Component
        customSupporterPage={customSupporterPage}
        fundraisingPage={fundraisingPage}
        onNext={onNext}
        user={user}
      />
      {!required && (
        <button className={classNames.skip} onClick={onNext}>
          Skip
        </button>
      )}
    </FlatModal>
  )
}

export default compose(
  withRouter,
  withStyles(styles)
)(OnboardingWizard)
